import { NewBadge } from "@certn/cascadia-react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useTranslation } from "react-i18next";

export function AdjudicationBetaBadge() {
  const { t } = useTranslation();

  const { showClientAdjudicationBeta } = useFlags();

  if (!showClientAdjudicationBeta) {
    return null;
  }

  return (
    <NewBadge
      type="bold"
      testID="adjudication-beta-badge"
      size="large"
      padding="space-05"
    >
      {t("Beta")}
    </NewBadge>
  );
}
